<template>
  <div>
    <div v-if="!mobile" class="q-pa-xs" id="base-desktop">
      <div class="col-12 container-certificado">
        <div class="row col-12">
          <div style="width: 12%" class="column justify-around top q-pa-sm">
            <q-img
              v-if="$store.state.autenticacao.logo.logoImpressao"
              :src="$store.state.autenticacao.logo.logoImpressao"
            />
            <q-img v-else src="../../../../assets/MULTPEX_VETOR.png" />
          </div>
        </div>
        <div class="row col-12 justify-center q-mt-xs">
          <span style="16px" class="text-h5 text-bold"
            >Termo de Aceite de Entrega de EPIs</span
          >
        </div>
        <div class="row col-12 justify-center q-mt-sm q-px-sm">
          <div class="row col-12 texto-conteudo-certificado">
            <ol>
              <li>
                Recebi da empresa Metal One Steel Plate Processing do Brasil
                Ltda, CNPJ: 18.321.024/0001-08no qual presto serviços como
                empregado, a posse gratuita de Equipamentos de Proteção
                Individuale instrumentos de trabalho, para uso diário em
                serviço, conforme prescrito na C.L.T em seu artigo166 e
                regulamento pela NR-6, item 6.2 e NR-4, item 4.2.
              </li>
              <li>Por outro lado estou ciente e me comprometo:</li>
              <ul>
                <li>
                  a) a devolvê-los na hipótese de rescisão, seja a que título
                  for;
                </li>
                <li>
                  b) a usá-los durante toda a jornada de trabalho, reconhecendo
                  expressamente que a sua não utilizaçãoconﬁgura falta;
                </li>
                <li>
                  c) a devolver os Equipamentos de Proteção Individual e os
                  instrumentos de trabalho usados, quandodas reposições.
                </li>
              </ul>
              <li>
                Na hipótese de substituição dos Equipamentos de Proteção
                Individual e dos instrumentos detrabalho usados por novos, se
                não efetivar a devolução, a empregadora estará autorizada a
                levar ameu débito, em folha de pagamento, o valor atualizado
                correspondente à não devolução.
              </li>
              <li>
                Declaro que conforme previsto em C.L.T, artigo 158, parágrafo
                único, alínea D, na NR-6, item 6.7.1,na NR-4, item 4.6 e nas
                Normas de Segurança da empresa Metal One Steel Plate Processing
                doBrasil Ltda, usar os EPI’s durante toda a jornada de trabalho,
                reconhecendo expressamente que asua não utilização conﬁgura
                falta grave capitulada na letra “h”. do artigo 482, da C.L.T,
                como ato deindisciplina ensejadora da rescisão de meu contrato
                de trabalho por justa causa. Declaro ainda,responsabilizar-me
                pela guarda e conservação do EPI’s que me forem conﬁados e que,
                naimpossibilidade de seu uso, deverei comunicar a cheﬁa
                imediatamente, para as providências queﬁzerem necessárias, e o
                devolverei após o vencimento de duração estipulada ou em caso de
                dispensa,reembolsando a Empresa no caso de dano ou extravio.
              </li>
              <li>
                O valor dos Equipamentos de Proteção Individual e dos
                instrumentos de trabalho, não integraem meu salário, nem aumenta
                consoante a lei.
              </li>
              <li>
                Por último declaro ter recebido as devidas instruções para o uso
                adequado, guarda, conservação e higienização dos Equipamentos de
                Proteção Individual.
              </li>
            </ol>
            <div class="row col-12 q-ml-xl">
              <span class="text-bold"
                >Aceite Coletado em: {{ dataCertificado.data }}</span
              >
            </div>
          </div>
        </div>
        <div class="row col-12 justify-around texto-impressao">
          <div class="col-2 text-weight-bold" style="margin-top: 22px">
            <div
              v-if="funcionarioDados.authContent"
              class="row col-12 justify-center q-mb-xs"
            >
              <q-img
                v-if="funcionarioDados.authType == 'biometria'"
                height="80px"
                width="150px"
                fit="contain"
                :src="funcionarioDados.authContent"
              />
              <q-img
                height="80px"
                width="150px"
                fit="contain"
                v-else
                :src="funcionarioDados.authContent"
              />
            </div>
            <div style="border-top: solid 1px black"></div>
            <div class="row col-12 justify-center q-my-sm">COLABORADOR</div>
            <div class="row col-12 justify-start q-my-sm">
              {{ funcionarioDados.nome?.toLocaleUpperCase() }}
            </div>
            <div class="row col-12 justify-start">
              ID: {{ funcionarioDados.matricula }}
            </div>
          </div>
        </div>
        <div class="row col-12 justify-end">
          <div style="width: 12%" class="column justify-around top q-pa-sm">
            <q-img
              v-if="$store.state.autenticacao.logo.logoImpressao"
              :src="$store.state.autenticacao.logo.logoImpressao"
            />
            <q-img v-else src="../../../../assets/MULTPEX_LOGO.png" />
          </div>
        </div>
      </div>
    </div>
    <div v-else style="overflow: scroll; width: 100%">
      <div class="q-pa-xs" id="base-mobile">
        <div class="col-12 container-certificado">
          <div class="row col-12">
            <div style="width: 12%" class="column justify-around top q-pa-sm">
              <q-img
                v-if="$store.state.autenticacao.logo.logoImpressao"
                :src="$store.state.autenticacao.logo.logoImpressao"
              />
              <q-img v-else src="../../../../assets/MULTPEX_VETOR.png" />
            </div>
          </div>
          <div class="row col-12 justify-center q-mt-xs">
            <span style="16px" class="text-h5 text-bold"
              >Termo de Aceite de Entrega de EPIs</span
            >
          </div>
          <div class="row col-12 justify-center q-mt-sm q-px-sm">
            <div class="row col-12 texto-conteudo-certificado">
              <ol>
                <li>
                  Recebi da empresa Metal One Steel Plate Processing do Brasil
                  Ltda, CNPJ: 18.321.024/0001-08no qual presto serviços como
                  empregado, a posse gratuita de Equipamentos de Proteção
                  Individuale instrumentos de trabalho, para uso diário em
                  serviço, conforme prescrito na C.L.T em seu artigo166 e
                  regulamento pela NR-6, item 6.2 e NR-4, item 4.2.
                </li>
                <li>Por outro lado estou ciente e me comprometo:</li>
                <ul>
                  <li>
                    a) a devolvê-los na hipótese de rescisão, seja a que título
                    for;
                  </li>
                  <li>
                    b) a usá-los durante toda a jornada de trabalho,
                    reconhecendo expressamente que a sua não utilizaçãoconﬁgura
                    falta;
                  </li>
                  <li>
                    c) a devolver os Equipamentos de Proteção Individual e os
                    instrumentos de trabalho usados, quandodas reposições.
                  </li>
                </ul>
                <li>
                  Na hipótese de substituição dos Equipamentos de Proteção
                  Individual e dos instrumentos detrabalho usados por novos, se
                  não efetivar a devolução, a empregadora estará autorizada a
                  levar ameu débito, em folha de pagamento, o valor atualizado
                  correspondente à não devolução.
                </li>
                <li>
                  Declaro que conforme previsto em C.L.T, artigo 158, parágrafo
                  único, alínea D, na NR-6, item 6.7.1,na NR-4, item 4.6 e nas
                  Normas de Segurança da empresa Metal One Steel Plate
                  Processing doBrasil Ltda, usar os EPI’s durante toda a jornada
                  de trabalho, reconhecendo expressamente que asua não
                  utilização conﬁgura falta grave capitulada na letra “h”. do
                  artigo 482, da C.L.T, como ato deindisciplina ensejadora da
                  rescisão de meu contrato de trabalho por justa causa. Declaro
                  ainda,responsabilizar-me pela guarda e conservação do EPI’s
                  que me forem conﬁados e que, naimpossibilidade de seu uso,
                  deverei comunicar a cheﬁa imediatamente, para as providências
                  queﬁzerem necessárias, e o devolverei após o vencimento de
                  duração estipulada ou em caso de dispensa,reembolsando a
                  Empresa no caso de dano ou extravio.
                </li>
                <li>
                  O valor dos Equipamentos de Proteção Individual e dos
                  instrumentos de trabalho, não integraem meu salário, nem
                  aumenta consoante a lei.
                </li>
                <li>
                  Por último declaro ter recebido as devidas instruções para o
                  uso adequado, guarda, conservação e higienização dos
                  Equipamentos de Proteção Individual.
                </li>
              </ol>
              <div class="row col-12 q-ml-xl">
                <span class="text-bold"
                  >Aceite Coletado em: {{ dataCertificado.data }}</span
                >
              </div>
            </div>
          </div>
          <div class="row col-12 justify-around texto-impressao">
            <div class="col-2 text-weight-bold" style="margin-top: 22px">
              <div
                v-if="funcionarioDados.authContent"
                class="row col-12 justify-center q-mb-xs"
              >
                <q-img
                  v-if="funcionarioDados.authType == 'biometria'"
                  height="80px"
                  width="150px"
                  fit="contain"
                  :src="funcionarioDados.authContent"
                />
                <q-img
                  height="80px"
                  width="150px"
                  fit="contain"
                  v-else
                  :src="funcionarioDados.authContent"
                />
              </div>
              <div style="border-top: solid 1px black"></div>
              <div class="row col-12 justify-center q-my-sm">COLABORADOR</div>
              <div class="row col-12 justify-start q-my-sm">
                {{ funcionarioDados.nome?.toLocaleUpperCase() }}
              </div>
              <div class="row col-12 justify-start">
                ID: {{ funcionarioDados.matricula }}
              </div>
            </div>
          </div>
          <div class="row col-12 justify-end">
            <div style="width: 12%" class="column justify-around top q-pa-sm">
              <q-img
                v-if="$store.state.autenticacao.logo.logoImpressao"
                :src="$store.state.autenticacao.logo.logoImpressao"
              />
              <q-img v-else src="../../../../assets/MULTPEX_LOGO.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();

    const capacitacaoId = route.params.capacitacaoId;
    const funcionarioId = route.params.funcionarioId;
    const treinamento = ref();
    const options = ref({
      treinamentoOptions: [],
    });
    const dadosCertificado = ref([]);
    const dataCertificado = ref({ dataFormatada: "", data: "" });
    const funcionarioDados = ref("");
    const instrutor = ref(null);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile = ref(true);
    }

    const receberDetalhesCertificado = async () => {
      try {
        store.dispatch("pdt/hiddenHeader", false);
        const response = await store.dispatch(
          "treinamento/detalharCapacitacao",
          {
            capacitacao_id: capacitacaoId,
          }
        );
        response.data.treinamentos.forEach((treinamento) => {
          options.value.treinamentoOptions.push({
            label: treinamento.nome,
            value: treinamento.treinamentoId,
            instrutor: treinamento.instrutor,
          });
        });
        response.data.funcionarios.forEach((funcionario) => {
          if (funcionario.funcionarioId == funcionarioId) {
            funcionarioDados.value = funcionario;
          }
        });
        treinamento.value = options.value.treinamentoOptions[0];
        if (funcionarioDados.value.dataConfirmacao != null) {
          let data = funcionarioDados.value.dataConfirmacao
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("/");
          gerarData(data);
        }
        if (mobile.value) {
          zoomOut();
        }
        salvarPdf();
      } catch (error) {
        console.log(error);
      }
    };

    const gerarData = (data) => {
      dataCertificado.value.data = data;
      const mes = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];
      const dataPartes = data.split("/");
      const dia = parseInt(dataPartes[0], 10);
      const mesIndex = parseInt(dataPartes[1], 10) - 1;
      const year = parseInt(dataPartes[2], 10);

      const monthName = mes[mesIndex];

      dataCertificado.value.dataFormatada = `${dia} de ${monthName} de ${year}`;
    };

    const zoomOut = () => {
      const content = document.getElementById("base-mobile");
      content.style.transform = "scale(0.9)";
      content.style.width = `300%`;
      content.style.height = `100%`;
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const centerX = (windowWidth - content.clientWidth) / 2;
      const centerY = (windowHeight - content.clientHeight) / 2;

      content.style.transformOrigin = "top left";
      content.style.left = centerX + "px";
      content.style.top = centerY + "px";
    };

    const salvarPdf = async () => {
      quasar.notify({
        message: "Aguarde enquanto o PDF é gerado.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      setTimeout(() => {
        let data = document.getElementById(
          mobile.value ? "base-mobile" : "base-desktop"
        );
        var hoje = new Date();
        let dataGerado = `${hoje.getDate()}/${hoje.getMonth()}/${hoje.getFullYear()} ${hoje.getHours()}:${
          hoje.getMinutes() /* < 10 ? "0" + hoje.getMinutes() : hoje.getMinutes()*/
        }:${hoje.getMilliseconds()}`;
        html2canvas(data, {
          useCORS: true,
        }).then((canvas) => {
          var imgWidth = 295;
          var pageHeight = 210;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;

          var heightLeft = imgHeight;
          const imgData = canvas.toDataURL("image/jpeg");

          var doc = new jsPDF("l", "mm", "a4", true);
          var position = 2;
          doc.addImage(
            imgData,
            "JPEG",
            1,
            position,
            imgWidth - 0,
            imgHeight + 0
          );
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(
              imgData,
              "JPEG",
              1,
              position,
              imgWidth - 0,
              imgHeight + 0
            );
            heightLeft -= pageHeight;
          }
          doc.save(
            `certificado_treinamento_${funcionarioDados.value.nome}_${dataGerado}`
          );
        });
      }, 3000);
    };

    onMounted(receberDetalhesCertificado);

    return {
      treinamento,
      options,
      capacitacaoId,
      receberDetalhesCertificado,
      funcionarioId,
      dadosCertificado,
      gerarData,
      dataCertificado,
      funcionarioDados,
      instrutor,
      mobile,
    };
  },
};
</script>

<style scoped>
.container-certificado {
  border: solid 5px black;
  border-radius: 2px;
  padding: 7px;
}
.texto-certificado {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
ul {
  list-style: none;
  margin: 0px;
  padding-left: 4px;
}
@page {
  orientation: landscape;
}
@media print {
  html,
  body {
    width: 210mm;
    height: 297mm;
  }
  .texto-impressao {
    font-size: 11px;
  }
  .texto-conteudo-certificado {
    font-size: 14px;
  }
}
</style>
